import React, { useState, useEffect } from "react";
import "../../../Styles/Users.css";
import CourseHeader from "../../../Components/CourseHeader";
import { icons } from "../../../Assests/icons-imports/icons";
import CommonDataTable from "../../../Components/CommonDataTable";
import { Helmet } from "react-helmet-async";
import useGetApi from "../../../services/useGetApi";
import { Form, Input, Button } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import IconButton from "../../../Components/IconButton";

const ManageAdmins = () => {
  const [isLoading, error, userData, getData] = useGetApi(
    `users?role=admin`,
    [],
    true
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData(`users?role=admin`);
  }, []);

  const handleEdit = () => {
    console.log("edit");
  };

  const handleDelete = () => {
    console.log("handleDelete");
  };

  const handleView = () => {
    console.log("handleView");
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <IconButton
            icon={EditOutlined}
            onClick={handleEdit}
            style={{ color: "blue" }}
          />
          <IconButton
            icon={DeleteOutlined}
            onClick={handleDelete}
            style={{ color: "red" }}
          />
          <IconButton
            icon={EyeOutlined}
            onClick={handleView}
            style={{ color: "green" }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Manage Admins | LMS-admin</title>
      </Helmet>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 w-100">
          <CourseHeader
            header={"Admins"}
            btnName={"Add Admin"}
            icon={icons.apple_icon}
            redirectTo={"/add-admin"}
          />
          <div className="bg-white p-3 mt-3">
            <CommonDataTable
              columns={columns}
              dataSource={userData}
              loading={loading}
              tableTitle={"Admins"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageAdmins;
